import { CrossStorageClient } from "cross-storage";

export const storage = new CrossStorageClient(
  process.env.REACT_APP_CROSS_STORAGE_URL || "",
  {}
);
